<template>
  <FusionBaseDialog
    @close="close"
    :open="open"
    :title="$t('map.deviceSettings.title')"
    icon="mdi-delete"
    data-cy="deviceUnregisterDialog"
    persistentOverlay
    padded
  >
    <DeviceUnregisterCard
      :deviceId="deviceId"
      :useWebsite="useWebsite"
      :deviceUnregistering="deviceUnregistering"
    />
    <template v-slot:actions>
      <DeviceUnregisterActions
        :deviceId="deviceId"
        :useWebsite="useWebsite"
        @device-unregistering="handleDeviceUnregistering"
        @unregister="handleUnregister"
        @close="close"
      />
    </template>
  </FusionBaseDialog>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import DeviceUnregisterCard from './DeviceUnregisterCard.vue'
import DeviceUnregisterActions from './DeviceUnregisterActions.vue'

export default defineComponent({
  name: 'DeviceUnregisterDialog',
  props: {
    open: Boolean,
    deviceId: String,
    useWebsite: { type: Boolean, default: true }
  },
  emits: ['close', 'unregister'],
  components: {
    DeviceUnregisterCard,
    DeviceUnregisterActions
  },
  data() {
    return {
      deviceUnregistering: false
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    handleDeviceUnregistering(value: boolean) {
      this.deviceUnregistering = value
    },
    handleUnregister() {
      this.$emit('unregister')
      this.close()
    }
  }
})
</script>
